// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2q0Yx","containerItemsCenter":"Skeleton_containerItemsCenter__2bVcG"};